import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface SectionEditor {
    _id: string;
    fullName: string;
    email: string;
}

interface SectionEditorContextType {
    sectionEditor: SectionEditor | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const SectionEditorContext = createContext<SectionEditorContextType>({
    sectionEditor: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useSectionEditor = () => useContext(SectionEditorContext);

export const SectionEditorProvider = ({ children }: { children: ReactNode }) => {
    const [sectionEditor, setSectionEditor] = useState<SectionEditor | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('sectionEditorToken');
        const storedSectionEditor = localStorage.getItem('sectionEditorData');

        if (storedToken && storedSectionEditor) {
            setToken(storedToken);
            setSectionEditor(JSON.parse(storedSectionEditor));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('sectionEditorToken');
        localStorage.removeItem('sectionEditorData');
        setSectionEditor(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <SectionEditorContext.Provider value={{
            sectionEditor,
            token,
            isAuthenticated: !!token && !!sectionEditor,
            logout,
            loading
        }}>
            {children}
        </SectionEditorContext.Provider>
    );
};
